/* eslint-disable import/prefer-default-export */
export { default as BlogOverviewTemplate } from './BlogOverviewTemplate';
